export default function () {
  const obsEls = document.querySelectorAll(".js-inViewObs");
  const IN_VIEW_CLASS = "in-view";

  obsEls.forEach(function (widget) {
    let threshold = parseFloat(widget.dataset.obsThreshold);
    if (Number.isNaN(threshold)) {
      threshold = 0.25;
    }

    const obs = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            widget.classList.add(IN_VIEW_CLASS);
          } else {
            widget.classList.remove(IN_VIEW_CLASS);
          }
        });
      },
      { threshold }
    );
    obs.observe(widget);
  });
}
